import React, { useEffect, useState, useContext } from "react";
import Characters from "./assets_character";
import ShapesAndProps from "./ShapesAndProps";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/mycontext.component";
import Shape from "./Shapes";
import TickerContext from "../../../../context/ticker";
import AssetsCharacterWrapper from "./assetsCharacterWrapper";
import AssetSearch from "../../../../Search/AssetSearch";
import AssetPropSearch from "../../../../Search/AssetPropSearch";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";
import TTSSettings from "../../../../TextToSpeech/TTSSettings";
export const AssetsWrapper = (props) => {
  const { Goto, charcterFolder, setcharcterFolder } = useContext(TickerContext);

  const { authenticationData } = useContext(AuthContext);
  const { setisTextInputOrAreaFocus } = useContext(MyContext);
  const [ActiveTab, setActiveTab] = useState("Characters");

  const [propsFolder, setPropsFolder] = useState([]);

  const [ShapesFolder, SetShapesFolder] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchFolder, setSearchFolder] = useState([]);
  const [searchPropFolder, setSearchPropFolder] = useState([]);

  useEffect(() => {
    if (Goto.innerMenu != null) {
      if (Goto.innerMenu === "Char") {
        setActiveTab("Characters");
      } else if (Goto.innerMenu === "prop") {
        setActiveTab("Props");
      } else if (Goto.innerMenu === "shape") {
        setActiveTab("Objects");
      }
    }
  }, [Goto]);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  useEffect(() => {
    if (charcterFolder.length === 0) {
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Character/GetCharacterChategories",
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          let array = response.data.categories;
          // Commenting it to remove my character category...
          // let FolderArray = [
          //   {
          //     id: 0,
          //     category: "My Characters",
          //     path: "Assets/StaticCharacter/MyCharacter.svg",
          //     items: [],
          //   },
          // ];
          let FolderArray = [];
          for (let i = 0; i < array.length; i++) {
            let obj = {
              id: array[i].id,
              category: array[i].categoryName,
              path: array[i].categoryImagePath,
              items: [],
            };
            FolderArray.push(obj);
          }
          setcharcterFolder(FolderArray);
        })
        .catch((error) => {
          //console.log(error);
        });
    }

    //getPropsFolderData(); // Getting Props Categories & Data
    getObjectFolderData();
  }, []);

  // async function getPropsFolderData() {
  //   axios
  //     .get(
  //       authenticationData.ApiBaseURL +
  //         "/api/Administration/getPropsFolderData",
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: "Bearer " + authData.access_token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setPropsFolder([...response.data.response]);
  //     });
  // }

  async function getObjectFolderData() {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getObjectFolderData",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        SetShapesFolder([...response.data.response]);
      });
  }

  async function getObjectFolderDataBykeyword(keyword) {
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getObjectFolderDataBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setSearchFolder([]);
        setSearchFolder([...response.data.response]);
      });
  }

  async function getPropFolderDataBykeyword(keyword) {
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getPropFolderDataBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setSearchPropFolder([]);
        setSearchPropFolder([...response.data.response]);
      });
  }

  const [propGlobal, setpropGlobal] = useState(false);
  const [OpenCategory, setOpenCategory] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isPropSearch, setIsPropSearch] = useState(false);

  const SearchAsset = (e) => {
    if (e.keyCode === 13) {
      if (searchKeyword == "") {
        setIsSearch(false);
        setIsPropSearch(false);
        return;
      }

      e.preventDefault();
      if (ActiveTab == "Objects") {
        //alert(ActiveTab)
        setIsSearch(true);
        getObjectFolderDataBykeyword(searchKeyword);
      } else if (ActiveTab == "Props") {
        setIsPropSearch(true);
        getPropFolderDataBykeyword(searchKeyword);
      }
    } else {
      setIsSearch(false);
      setIsPropSearch(false);
    }
  };

  return (
    <div className="innerWrapperPanel">
      <div className="templatesWrapper2">
        <div className="divLabel mb-3">Assets</div>

        <div className="tabs mb-3">
          <div className="p2">
            <div
              className={
                "tabButton" + (ActiveTab === "Characters" ? " activeTab" : "")
              }
              onClick={() => {
                setActiveTab("Characters");
                setSearchKeyword("");
              }}
            >
              Characters
            </div>

            <div
              className={
                "tabButton" + (ActiveTab === "MyCharacters" ? " activeTab" : "")
              }
              onClick={() => {
                setActiveTab("MyCharacters");
                setSearchKeyword("");
              }}
            >
              My Characters
            </div>

            <div
              className={
                "tabButton" + (ActiveTab === "Talking" ? " activeTab" : "")
              }
              title="Characters that move their mouth while they speak"
              onClick={() => {
                setActiveTab("Talking");
                setSearchKeyword("");
              }}
            >
              Talking
            </div>

            {/* <div
              className={
                "tabButton" + (ActiveTab === "Props" ? " activeTab" : "")
              }
              onClick={() => {
                setActiveTab("Props");
                setSearchKeyword("");
                setIsPropSearch(false);
              }}
            >
              Props
            </div> */}

            {/* <div
              className={
                "tabButton" + (ActiveTab === "Objects" ? " activeTab" : "")
              }
              onClick={() => {
                setActiveTab("Objects");
                setSearchKeyword("");
                setIsSearch(false);
              }}
            >
              Objects
            </div> */}
          </div>
        </div>

        {ActiveTab != "Characters" && ActiveTab !== "Talking" && (
          <div className="searchBarParent" style={{ padding: "0px 12px" }}>
            <span className="material-icons SearchIconCustom">search</span>
            <input
              multiple
              type="text"
              onKeyUp={(e) => SearchAsset(e)}
              value={searchKeyword}
              onChange={(e) => {
                setSearchKeyword(e.target.value);
                setIsPropSearch(false);
              }}
              onFocus={() => setisTextInputOrAreaFocus(true)}
              onBlur={() => setisTextInputOrAreaFocus(false)}
              className="search customInput searchpad"
              placeholder="Search Here ..."
            />
          </div>
        )}
        {props.IsTTSShow ? (
          <>
            <TTSSettings
              LayersData={props.TTSData?.LayersData}
              setLayersData={props.TTSData?.setLayersData}
              values={props.TTSData?.value}
              setoverlaydiv={props.TTSData?.setoverlaydiv}
              overlaydiv={props.TTSData?.overlaydiv}
              overlayHide={props.TTSData?.overlayHide}
              setoverlayHide={props.TTSData?.setoverlayHide}
              parentWidth={props.TTSData?.parentWidth}
              parentHeight={props.TTSData?.parentHeight}
              EditorTrackInner={props.TTSData?.EditorTrackInner}
            />
          </>
        ) : (
          <div
            className="assetsScrol style-1"
            style={{
              height:
                ActiveTab === "Characters" || ActiveTab === "Talking"
                  ? "calc(100% - 120px)"
                  : "calc(100% - 170px)",
            }}
          >
            {/* {ActiveTab === "Characters" && charcterFolder.map((lmc, index) =>
                  <Characters key={('character' + index)} item={lmc.items} name={lmc.category} path={lmc.path} setChrPopData={props.setChrPopData}
                      setchrPop={props.setchrPop} id={lmc.id} StartClicking={props.StartClicking} CreateStart={props.CreateStart} />
              )} */}

            {ActiveTab === "Objects" &&
              !isSearch &&
              ShapesFolder.map((lmc, index) => (
                <Shape
                  getObjectFolderData={getObjectFolderData}
                  key={"shapes" + index}
                  item={lmc.items}
                  path={lmc.path}
                  name={lmc.text}
                />
              ))}

            {ActiveTab === "Objects" && isSearch && (
              <AssetSearch
                getObjectFolderDataBykeyword={getObjectFolderDataBykeyword}
                searchKeyword={searchKeyword}
                item={searchFolder}
              />
            )}

            {ActiveTab === "Props" && isPropSearch && (
              <AssetPropSearch
                getPropFolderDataBykeyword={getPropFolderDataBykeyword}
                searchKeyword={searchKeyword}
                item={searchPropFolder}
              />
            )}

            {ActiveTab === "Props"
              ? !isPropSearch &&
                propsFolder.length == 0 && (
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: loader,
                    }}
                    height={200}
                    width={200}
                    isStopped={false}
                    isPaused={false}
                  />
                )
              : ActiveTab == "Objects" &&
                !isSearch &&
                ShapesFolder.length == 0 && (
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: loader,
                    }}
                    height={200}
                    width={200}
                    isStopped={false}
                    isPaused={false}
                  />
                )}

            {ActiveTab === "Characters" && charcterFolder.length == 0 && (
              <Lottie
                options={{ loop: true, autoplay: true, animationData: loader }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
              />
            )}

            {/* {ActiveTab === "Props" &&
              !isPropSearch &&
              propsFolder.map((lmc, index) => (
                <ShapesAndProps
                  getPropsFolderData={getPropsFolderData}
                  skey={"props" + index}
                  name={lmc.text}
                  icon={lmc.icon}
                  item={lmc.items}
                  indexes={index}
                  propGlobal={propGlobal}
                  setpropGlobal={setpropGlobal}
                />
              ))} */}

            {ActiveTab === "Characters" && (
              <AssetsCharacterWrapper
                className="bg-primary"
                // key={"character" + index}
                // item={lmc.items}
                // name={lmc.category}
                // path={lmc.path}
                setChrPopData={props.setChrPopData}
                setchrPop={props.setchrPop}
                // id={lmc.id}
                StartClicking={props.StartClicking}
                CreateStart={props.CreateStart}
                OpenCategory={OpenCategory}
                setOpenCategory={setOpenCategory}
                ActiveTab={ActiveTab}
                // indexes={index}
              />
            )}
            {ActiveTab === "MyCharacters" && (
              <AssetsCharacterWrapper
                className="bg-primary"
                // key={"character" + index}
                // item={lmc.items}
                // name={lmc.category}
                // path={lmc.path}
                setChrPopData={props.setChrPopData}
                setchrPop={props.setchrPop}
                // id={lmc.id}
                StartClicking={props.StartClicking}
                CreateStart={props.CreateStart}
                OpenCategory={OpenCategory}
                setOpenCategory={setOpenCategory}
                ActiveTab={ActiveTab}
                // indexes={index}
              />
            )}
            {ActiveTab === "Talking" && (
              <AssetsCharacterWrapper
                className="bg-primary"
                // key={"character" + index}
                // item={lmc.items}
                // name={lmc.category}
                // path={lmc.path}
                setChrPopData={props.setChrPopData}
                setchrPop={props.setchrPop}
                // id={lmc.id}
                StartClicking={props.StartClicking}
                CreateStart={props.CreateStart}
                OpenCategory={OpenCategory}
                setOpenCategory={setOpenCategory}
                ActiveTab={ActiveTab}
                // indexes={index}
              />
            )}
            {/* {ActiveTab === "Characters" &&
              charcterFolder.map((lmc, index) => (
                <AssetsCharacterWrapper
                  className="bg-primary"
                  key={"character" + index}
                  item={lmc.items}
                  name={lmc.category}
                  path={lmc.path}
                  setChrPopData={props.setChrPopData}
                  setchrPop={props.setchrPop}
                  id={lmc.id}
                  StartClicking={props.StartClicking}
                  CreateStart={props.CreateStart}
                  OpenCategory={OpenCategory}
                  setOpenCategory={setOpenCategory}
                  indexes={index}
                />
              ))} */}
          </div>
        )}
      </div>
    </div>
  );
};
export default AssetsWrapper;
